// extracted by mini-css-extract-plugin
export default {"backgroundimageStarAttractions":"starAttractions_backgroundimageStarAttractions__dTiDP"};